import { FileText, Image as ImageIcon, Paperclip, Download } from "lucide-react";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fileUrl = (url) => {
  if (!url) return "";
  if (/^https?:\/\//.test(url)) return url;
  return `${API_BASE}${url.startsWith("/") ? "" : "/"}${url}`;
};

const iconFor = (type = "") =>
  type.includes("pdf") ? FileText : type.startsWith("image") ? ImageIcon : Paperclip;

// Client-side list of documents attached to a block — displayed under the price.
export const Attachments = ({ attachments = [], compact = false }) => {
  if (!attachments.length) return null;
  return (
    <div className={compact ? "space-y-1.5" : "space-y-2"} data-testid="attachments">
      {attachments.map((a, i) => {
        const Icon = iconFor(a.type);
        return (
          <a
            key={i}
            href={fileUrl(a.url)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`attachment-${i}`}
            className="group flex items-center gap-2.5 text-sm text-[#4d4d4d] hover:text-[#7A4B3B] transition-colors"
          >
            <Icon className="h-4 w-4 shrink-0 text-[#96836B]" />
            <span className="truncate underline decoration-[#D9D5CC] underline-offset-2 group-hover:decoration-[#7A4B3B]">{a.name || "Document"}</span>
            <Download className="h-3.5 w-3.5 shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" />
          </a>
        );
      })}
    </div>
  );
};

export default Attachments;
